import { createSelector, Selector } from 'reselect'

import { ConsumptionsState } from './consumption.reducer'

import { RootState } from '~/core/store/root.reducer'

type GetConsumption = Selector<RootState, ConsumptionsState>

const getConsumption: GetConsumption = (state) => state.consumptions

export const selectConsumption = (id: string) =>
  createSelector(getConsumption, (consumptions) =>
    consumptions && consumptions[id] ? consumptions[id].data : undefined,
  )

export const selectConsumptionLoading = (id: string) =>
  createSelector(getConsumption, (consumptions) =>
    consumptions && consumptions[id] ? consumptions[id].loading : false,
  )

export const selectConsumptionError = (id: string) =>
  createSelector(getConsumption, (consumptions) =>
    consumptions && consumptions[id] ? consumptions[id].error : undefined,
  )
